import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { ViewMovementList, ViewMovementsSearchType } from "../../ViewMovementList";
import { ModelRow } from "@mcleod/core";

export class RowActionViewMovements extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonViewMovements;
    }

    override getButtonId(): string {
        return "buttonViewMovements";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["driver1_id", "tractor", "trailer", "order_id"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        return;
    }

    override execute(props: PlanningTableRowActionProps) {
        const modelRow = props.selectedRows[0]?.data as ModelRow;
        if (modelRow == null) return;

        this.getButton().busy = true;
        const searchKey = modelRow.get("driver1_id") || modelRow.get("tractor") || modelRow.get("trailer") || modelRow.get("order_id");
        const searchType = !modelRow.isNull("driver1_id") ? ViewMovementsSearchType.DRIVER : !modelRow.isNull("tractor")
            ? ViewMovementsSearchType.TRACTOR
            : !modelRow.isNull("trailer") ? ViewMovementsSearchType.TRAILER : ViewMovementsSearchType.ORDER;
        ViewMovementList.openSlideout({search_key: searchKey, search_type: searchType});
        this.getButton().busy = false;
    }
}
